const hslToHex = (h: number, s: number, l: number) => {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

export const getPolygonColor = ({
  max,
  current,
  disabled,
}: {
  max: number;
  current: number | null;
  disabled: boolean;
}) => {
  if (disabled) {
    return hslToHex(0, 0, 50);
  }

  if (max && current) {
    const p = (current * 100) / max;
    const h = 100 - (120 * p) / 100;
    return hslToHex(h, 40, 40);
  }

  return hslToHex(120, 40, 40);
};
